import { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios"; // Import axios
import API_ENDPOINTS from "config/api";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgVideo from "assets/images/backgrounds/fondovideologin.webm";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // State for error message
  const [loading, setLoading] = useState(false); // Add loading state
  const navigate = useNavigate(); // Hook for navigation

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true when starting the login request
    setError(""); // Reset previous errors

    try {
      // Realiza la solicitud de login al backend
      const response = await axios.post(API_ENDPOINTS.AUTH.LOGIN, {
        email: email,
        password: password,
      });

      console.log("Login response:", response); // Verifica la respuesta del backend

      if (response.data.message === "Login successful") {
        // Guarda el token en localStorage
        localStorage.setItem("authToken", response.data.token);

        // Configura Axios para que el token se envíe en las futuras solicitudes
        axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;

        // Limpia el mensaje de error
        setError("");

        // Redirige al dashboard
        navigate("/dashboard");
      } else {
        setError("Invalid email or password"); // Error general para login fallido
      }
    } catch (err) {
      // Show detailed error if response is available
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Login failed");
      } else {
        setError("An error occurred. Please try again.");
      }
      console.error("Login failed", err);
    } finally {
      setLoading(false); // Turn off loading state
    }
  };

  return (
    <BasicLayout video={bgVideo}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            SADEMS
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            {error && ( // Conditionally render error message
              <MDBox mb={2} textAlign="center">
                <MDTypography variant="body2" color="error">
                  {error}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)} // Update email state
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Update password state
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                {loading ? "Signing in..." : "Sign in"} {/* Show loading text */}
              </MDButton>
            </MDBox>
            <MDBox mt={2} textAlign="center">
              <MDTypography variant="caption" color="text" fontWeight="regular">
                <strong>Demo:</strong> demo@sadems.com / demo123
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
